import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useParams } from "react-router-dom";

export default function ViolationTypeFormPage() {
    const { id } = useParams(); // موجود فقط عند التعديل
    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    // الحقول
    const [name, setName] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    // جلب البيانات عند التعديل
    useEffect(() => {
        if (!id) return;

        const fetchViolationType = async () => {
            try {
                const res = await backEnd_request.get(`/ViolationTypes/${id}`);
                const vt = res.data;

                setName(vt.name ?? "");
                setIsActive(vt.isActive ?? true);

            } catch (err) {
                console.log(err.response?.data || err);
                setErrorMessage("فشل جلب بيانات نوع الضبط ❌");
            }
        };

        fetchViolationType();
    }, [id]);

    // إرسال البيانات
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage("");

        const payload = {
            name: name.trim(),
            isActive,
        };

        try {
            if (id) {
                // تعديل
                await backEnd_request.post(`/ViolationTypes/${id}`, payload);
                navigate("/admin/violation-types-management", {
                    state: { successMessage: "تم تعديل نوع الضبط بنجاح ✅" }
                });
            } else {
                // إضافة
                await backEnd_request.post(`/ViolationTypes`, payload);
                navigate("/admin/violation-types-management", {
                    state: { successMessage: "تم إضافة نوع الضبط بنجاح ✅" }
                });
            }
        } catch (err) {
            console.log(err.response?.data || err);
            setErrorMessage(err.response?.data?.message || "حدث خطأ أثناء الحفظ ❌");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container py-5">
            <h3 className="fw-bold text-primary mb-4">
                {id ? "تعديل نوع الضبط" : "إضافة نوع ضبط جديد"}
            </h3>

            {errorMessage && (
                <div className="alert alert-danger">{errorMessage}</div>
            )}

            <form key={id || "new"} onSubmit={handleSubmit}>

                <div className="mb-3">
                    <label className="form-label">اسم نوع الضبط</label>
                    <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <div className="form-check mb-4">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                        id="isActiveCheck"
                    />
                    <label className="form-check-label" htmlFor="isActiveCheck">
                        نوع الضبط نشط
                    </label>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? "جاري الحفظ..." : id ? "تعديل" : "إضافة"}
                </button>

                <button
                    type="button"
                    className="btn btn-secondary ms-2"
                    onClick={() => navigate("/admin/violation-types-management")}
                >
                    إلغاء
                </button>
            </form>
        </div>
    );
}
